import { Box, InputLabel, TextField, TextFieldProps, useTheme } from '@mui/material'
import React from 'react'

interface CustomTextFieldProps {
  label?: string
  sx?: TextFieldProps['sx']
}

export const CustomTextField: React.FC<CustomTextFieldProps & TextFieldProps> = (props) => {
  const theme = useTheme()
  const { sx, label, id = `field-${Math.random()}`, ...rest } = props

  return (
    <Box sx={{ width: '100%' }}>
      {label && (
        <InputLabel
          htmlFor={id}
          sx={{
            color: theme.palette.text.primary,
            mb: 1,
            fontWeight: 500,
            transform: 'none',
            position: 'static',
            textAlign: 'left',
            fontSize: '0.875rem',
          }}
        >
          {label}
        </InputLabel>
      )}{' '}
      <TextField
        {...rest}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${theme.palette.divider} !important`,
          },
          
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            borderRadius: '6px',
            color: theme.palette.text.primary,
            '& fieldset': {
              borderColor: theme.palette.divider,
            },
            '&:hover fieldset': {
              borderColor: theme.palette.divider,
            },
          },
          ...sx,
        }}
      />
    </Box>
  )
}
